import React from 'react';
import './PersonPhoto.css';

// IMPORT IMGAGES
import { PERSONAL_PHOTO } from './constants';

function PersonPhoto() {

  return(
    <img
      className='person-photo'
      src={PERSONAL_PHOTO}
      alt={`Фотография портрет`}
      />
  );
}
export default PersonPhoto;
